import React, { useEffect } from "react";
import Seat from "./Seat";
import useStore from "../store/store";
// import { Button } from "@mui/material";
// import RefreshIcon from "@mui/icons-material/Refresh";
import { styled } from "@mui/material/styles";
import { getPublicIP } from "../hooks/PublicIP";

export default function OfficeNY({ user }) {
  const [
    seats,
    seatMapNY0,
    seatMapNY1,
    seatMapNY2,
    seatMapNY3,
    seatMapNY4,
    seatMapNY5,
    seatMapNY6,
    setOffice,
    refreshSeats,
    office,
  ] = useStore((state) => [
    state.seats,
    state.seatMapNY0,
    state.seatMapNY1,
    state.seatMapNY2,
    state.seatMapNY3,
    state.seatMapNY4,
    state.seatMapNY5,
    state.seatMapNY6,
    state.setOffice,
    state.refreshSeats,
    state.office,
  ]);

  useEffect(() => {
    setOffice("NY");
    refreshSeats();
    getIp();
  }, []);

  const getIp = async () => {
    const ip = await getPublicIP();
    // console.log("ip in OfficeNY: ", ip);
    return ip;
  };

  // const refresh = async () => {
  //   refreshSeats();
  // };

  let index = 0;
  return (
    <div style={{ minWidth: "1024px" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <TopseatMap>
          {seatMapNY1.map((seatIndex, col) => (
            <Seat seatIndex={seatIndex} user={user} key={index++} />
          ))}
        </TopseatMap>
        <TopseatMap>
          {seatMapNY6.map((seatIndex, col) => (
            <Seat seatIndex={seatIndex} user={user} key={index++} />
          ))}
        </TopseatMap>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "25px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <MainseatMap>
              {seatMapNY2.map((cells, col) => {
                const lm = (col % 2) * 20;
                // console.log(col, lm);
                return (
                  <MainSeatColumn
                    sx={{
                      marginBottom: lm + "px",
                    }}
                    key={index++}
                  >
                    {cells.map((seatIndex) => (
                      <Seat seatIndex={seatIndex} user={user} key={index++} />
                    ))}
                  </MainSeatColumn>
                );
              })}
            </MainseatMap>
            <MainseatMap style={{marginLeft: "25px"}}>
              {seatMapNY3.map((cells, col) => {
                const lm = (col % 2) * 20;
                // console.log(col, lm);
                return (
                  <MainSeatColumn
                    sx={{
                      marginBottom: lm + "px",
                    }}
                    key={index++}
                  >
                    {cells.map((seatIndex) => (
                      <Seat seatIndex={seatIndex} user={user} key={index++} />
                    ))}
                  </MainSeatColumn>
                );
              })}
            </MainseatMap>{" "}
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <MainseatMap>
              {seatMapNY4.map((cells, col) => {
                const lm = (col % 2) * 20;
                // console.log(col, lm);
                return (
                  <MainSeatColumn
                    sx={{
                      marginBottom: lm + "px",
                    }}
                    key={index++}
                  >
                    {cells.map((seatIndex) => (
                      <Seat seatIndex={seatIndex} user={user} key={index++} />
                    ))}
                  </MainSeatColumn>
                );
              })}
            </MainseatMap>
            <MainseatMap style={{marginLeft: "25px"}}>
              {seatMapNY5.map((cells, col) => {
                const lm = (col % 2) * 20;
                // console.log(col, lm);
                return (
                  <MainSeatColumn
                    sx={{
                      marginBottom: lm + "px",
                    }}
                    key={index++}
                  >
                    {cells.map((seatIndex) => (
                      <Seat seatIndex={seatIndex} user={user} key={index++} />
                    ))}
                  </MainSeatColumn>
                );
              })}
            </MainseatMap>{" "}
          </div>
        </div>
        <TopseatMap>
          {seatMapNY0.map((seatIndex, col) => (
            <Seat seatIndex={seatIndex} user={user} key={index++} />
          ))}
        </TopseatMap>
      </div>
    </div>
  );
}

const TopseatMap = styled("div")({
  display: "flex",
  flexDirection: "column",
  margin: "25px",
  // alignItems: "center",
  // justifyContent: "space-evenly",
  // justifyContent: "flex-end",
  // justifyContent: "center",
  columnGap: "40px",
});

const MainseatMap = styled("div")({
  display: "flex",
  flexDirection: "column",
  margin: "1px",
  justifyContent: "center",
  alignItems: "center",
});

const MainSeatColumn = styled("div")({
  display: "flex",
  flexDirection: "row",
});

// const MainseatMap = styled("div")({
//   display: "flex",
//   flexDirection: "row",
//   margin: "10px",
//   justifyContent: "center",
// });

// const MainSeatColumn = styled("div")({
//   display: "flex",
//   flexDirection: "column",
// });

// const Bottom = styled("div")({
//   display: "flex",
//   flexDirection: "row",
//   justifyContent: "center",
// });
